module.exports = "<div class=aui-loader ng-show=$ctrl.show ng-class=\"{firstLoad:$ctrl.firstLoad == true}\"> <div class=\"aui-loader__container loader--fade text-center\"> <img src=" + require("./img/loader.gif") + "> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/loader/loader.html
// module id = 5
// module chunks = 0 1 2 4 5